import { computed } from 'vue'

export function useFormFieldDef(formData, fieldName, inputProps = null) {
  const fieldDef = computed(() => {
    if (!formData?.def || !fieldName) {
      return null
    }
    return formData.def[fieldName]
  })

  const isDisabled = computed(() => fieldDef.value?.options?.disabled || false)

  const inputId = computed(() => {
    if (!inputProps) {
      return ''
    }
    if (inputProps.inputId) {
      return inputProps.inputId
    }
    const name = fieldName || ''
    let escapedName = name
    if (name.includes('.')) {
      escapedName = name.replace(/\./g, '-')
    }
    return escapedName + (inputProps.formRef || '')
  })

  return {
    isDisabled,
    inputId,
  }
}
